import useApiQuery from 'shared/hooks/use-api-query';
import {AddressProps} from '../types';

const useAddressesByPhone = (phone?: string) => {
  return useApiQuery<AddressProps[]>({
    url: `/addresses/phones/${phone}`,
    enabled: !!phone && phone.length >= 10,
  });
};

export default useAddressesByPhone;
